
jQuery(document).ready(function() {
  var nav_link = jQuery('.usa-nav-link');
  //console.log(nav_link);
  //Open a dropdown list in desktop, and open a new subnav menu on mobile.
  for (var i = 0; i < nav_link.length; i++) {
    nav_link[i].addEventListener('click', function() {

      jQuery(this).parent().parent().find('> li').removeClass('menu-active');
      jQuery(this).parent().parent().find('> li').removeClass('menu-is-open');
      //jQuery(this).find('.svg-inline--fa').toggleClass('fa-chevron-down fa-chevron-left');
      jQuery(this).parent().parent().find('.svg-inline--fa').removeClass('fa-chevron-left');
      jQuery(this).parent().parent().find('.svg-inline--fa').addClass('fa-chevron-down');
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');
      var trident = ua.indexOf('Trident/');
      if(msie > 0 || trident > 0){
        if(jQuery(this).attr('aria-expanded') == 'true'){
          jQuery(this).parent().addClass('menu-active');
          jQuery('#search-placeholder').addClass('hidden-on-mobile');
          jQuery(this).parent().parent().parent().find(".form").addClass('hidden-on-mobile');
          jQuery(this).parent().parent().find('> li').addClass('menu-is-open');
          if(jQuery(window).width() < 951){
            jQuery(this).find('.svg-inline--fa').addClass('fa-chevron-left');
            jQuery(this).find('.svg-inline--fa').removeClass('fa-chevron-down');
          }
        }
        else{
          jQuery(this).parent().parent().parent().find(".form").removeClass('hidden-on-mobile');

        }
      }
      else{
        if(jQuery(this).attr('aria-expanded') == 'false'){
          jQuery(this).parent().addClass('menu-active');
          jQuery('#search-placeholder').addClass('hidden-on-mobile');
          jQuery(this).parent().parent().parent().find(".form").addClass('hidden-on-mobile');
          console.log(jQuery('#search-placeholder'));
          jQuery(this).parent().parent().find('> li').addClass('menu-is-open');
          if(jQuery(window).width() < 951){
            jQuery(this).find('.svg-inline--fa').addClass('fa-chevron-left');
            jQuery(this).find('.svg-inline--fa').removeClass('fa-chevron-down');
          }
        }
        else{
          jQuery(this).parent().parent().parent().find(".form").removeClass('hidden-on-mobile');

        }
      }
      jQuery('.usa-nav-submenu').each(function(){
        var padding = jQuery(this).find('.menu-title').outerHeight( true );
        if(jQuery(this).css('padding-top') < padding){
          jQuery(this).css('padding-top', padding);
        }
      });
    });
  }
  //Open the mobile menu
  var dol_menu_button = jQuery('button.dol-menu-button');
  dol_menu_button[0].addEventListener('click', function() {
    //jQuery('header').toggleClass('nav-is-open');
    jQuery('.nav-container').toggleClass('nav-is-open');
    jQuery('.agency-nav-container').toggleClass('nav-is-open');
  });

  //When you change between desktop and mobile, change the svgs to match mockup
  jQuery( window ).resize(function() {
    if(jQuery(window).width() > 1270){
      var nav_item = jQuery('usa-nav-primary').find('> li > button');
      var nav_arrow = jQuery('.usa-nav-primary').find('.svg-inline--fa');
      jQuery.each(nav_item , function(){
        if(jQuery(this).hasClass('fa-chevron-left')){
          jQuery(this).removeClass('fa-chevron-left');
          jQuery(this).addClass('fa-chevron-down');
        }
      });
      if (jQuery(nav_arrow).hasClass('fa-chevron-left')) {
        jQuery(nav_arrow).removeClass('fa-chevron-left');
        jQuery(nav_arrow).addClass('fa-chevron-down');
      }
      var agency_nav_item = jQuery('.cd-primary-nav').find('> li > a > span.menuitem');
      jQuery.each(nav_item , function(){
        if(jQuery(this).hasClass('fa-chevron-right')){
          jQuery(this).removeClass('fa-chevron-right');
          jQuery(this).addClass('fa-chevron-down');
        }
      });
    }
    else {
      var nav_item = jQuery('usa-nav-primary').find('> li > button');
      var nav_arrow = jQuery('usa-nav-primary').find('.svg-inline--fa');
      jQuery.each(nav_item , function() {
        if(jQuery(this).attr('aria-expanded') == 'true'){
          jQuery(this).removeClass('fa-chevron-down');
          jQuery(this).addClass('fa-chevron-left');
        }
      });
      if (jQuery(nav_arrow).hasClass('fa-chevron-down')) {
        jQuery(nav_arrow).removeClass('fa-chevron-down');
        jQuery(nav_arrow).addClass('fa-chevron-left');
      }
    }
  });
  //When you click outside of the menu or menu button, close everything
  jQuery('html').click(function(event) {
    var $trigger = jQuery("#header-content");
    if($trigger !== event.target && !$trigger.has(event.target).length){
      var $triggerAlt = jQuery("button.dol-menu-button");
      if($triggerAlt[0] !== event.target && !$triggerAlt.has(event.target).length){
        jQuery(".usa-mobile_nav-active").removeClass("usa-mobile_nav-active");
        jQuery(".usa-nav-link").attr('aria-expanded', function () {
          return 'false'; //
        });
        jQuery('.usa-nav-submenu').attr('aria-hidden', function () {
          return 'true';
        });
        var nav_item = jQuery('usa-nav-primary').find('> li > button');
        jQuery.each(nav_item , function(){
          if(jQuery(this).hasClass('fa-chevron-left')){
            jQuery(this).removeClass('fa-chevron-left');
            jQuery(this).addClass('fa-chevron-right');
          }
        });
        jQuery('.usa-nav-primary').find('> li').removeClass('menu-active menu-is-open');
        jQuery('.cd-primary-nav').find('> li').removeClass('menu-is-active menu-is-open');
        jQuery('.nav-container').removeClass('nav-is-open');
      }
    }
  });
  jQuery('.usa-nav-submenu').click(function(e){
    e.stopPropagation();
  });

  jQuery('.usa-nav-submenu').each(function(){
    var padding = jQuery(this).find('.menu-title').outerHeight( true );
    if(jQuery(this).css('padding-top') < padding){
      jQuery(this).css('padding-top', padding);
    }
  });
});

jQuery(document).click(function() {
  if (jQuery('#dol-primary-menu').hasClass('nav-is-open')) {
    jQuery('button.dol-menu-button').text('Close');
    if (jQuery('#dol-primary-menu').find('li.menu-is-open.menu-is-active')) {
        jQuery('li.menu-is-open.menu-is-active').find('.cd-secondary-nav').removeClass('is-hidden');
    }
  } else {
    jQuery('button.dol-menu-button').text('Menu');
      jQuery('li.menu-is-open.menu-is-active').find('.cd-secondary-nav').addClass('is-hidden');
  }

  if (jQuery(window).width() < 1270) {
    if (jQuery('li.menu-is-active a.selected').length) {
      jQuery('#search-placeholder').addClass('dNone');
      jQuery('#cd-primary-nav-secondary-desktop > li > a > span.menuarrow > svg').addClass('fa-chevron-left');
    } else {
      jQuery('#search-placeholder').removeClass('dNone');
      jQuery('#cd-primary-nav-secondary-desktop > li > a > span.menuarrow > svg').addClass('fa-chevron-down');
    }
  }
});

jQuery('.cd-secondary-nav').click(function(e){
   e.stopPropagation();
});